export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_USER = "CLEAR_USER";
export const GET_VIDEOS = "GET_VIDEOS";
export const UPLOAD_VIDEO = "UPLOAD_VIDEO";
export const GET_RESOURCE = "GET_RESOURCE";
export const ADD_ERROR = "ADD_ERROR";
export const ADD_LATEST = "ADD_LATEST";
export const CLEAR_LATEST = "CLEAR_LATEST";
export const SET_FILTER = "SET_FILTER";
export const GET_COMMENTS = "GET_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const GET_USER = "GET_USER";
export const GET_USERVIDEOS = "GET_USERVIDEOS";
export const GET_NOTES = "GET_NOTES";
export const GET_BOOKMARKS = "GET_BOOKMARKS";
export const FILTER_VIDEOS = "FILTER_VIDEOS";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const ADD_REPLY = "ADD_REPLY";
export const CLEAR_RESOURCE = "CLEAR_RESOURCE";
export const LOADING = "LOADING";
export const GET_CLASSES = "GET_CLASSES";
export const MOVE_DOWN = "MOVE_DOWN";
export const EDIT_CLASS = "EDIT_CLASS";
export const SET_CURRENT = "SET_CURRENT";
export const CLEAR_CURRENT = "CLEAR_CURRENT";
export const CLEAR_CLASSES = "CLEAR_CLASSES";
export const ADD_MORE = "ADD_MORE";
